export default __webpack_public_path__ + "static/media/TutorDashboard.809322f6.png";